import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'
import sql from '~/prix/utils/sql'

export const privateFileStatus = enumerated({
  pending: 'Pendente',
  uploaded: 'Enviado',
  deleted: 'Removido',
  failed: 'Falhou',
})

export const privateFileObject = z.object({
  id: z.string().uuid(),
  clientId: z.number().int(),
  kind: z.string(),
  bucketName: z.string(),
  objectPath: z.string(),
  originalFileName: z.string(),
  mimeType: z.string(),
  sizeBytes: z.number().int().nullish(),
  status: privateFileStatus,
  createdByUserId: z.string().nullish(),
  createdAt: dateOrIsoString(),
  updatedAt: dateOrIsoString(),
  deletedAt: dateOrIsoString().nullish(),
})

export type PrivateFileType = z.infer<typeof privateFileObject>

export const propertyMap = {
  id: sql`private_file.id`,
  clientId: sql`private_file.client_id`,
  kind: sql`private_file.kind`,
  bucketName: sql`private_file.bucket_name`,
  objectPath: sql`private_file.object_path`,
  originalFileName: sql`private_file.original_file_name`,
  mimeType: sql`private_file.mime_type`,
  sizeBytes: sql`private_file.size_bytes`,
  status: sql`private_file.status`,
  createdByUserId: sql`private_file.created_by_user_id`,
  createdAt: sql`private_file.created_at`,
  updatedAt: sql`private_file.updated_at`,
  deletedAt: sql`private_file.deleted_at`,
}
